import { render } from "./CourseBuilder.vue?vue&type=template&id=6fa33f34&scoped=true"
import script from "./CourseBuilder.vue?vue&type=script&lang=js"
export * from "./CourseBuilder.vue?vue&type=script&lang=js"

import "./CourseBuilder.vue?vue&type=style&index=0&id=6fa33f34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fa33f34"]])

export default __exports__